import React from "react";
import { Card, Container, Row, Col, Form, Button, Image } from "react-bootstrap";
import { motion } from "framer-motion";
import AboutUsImage from "../Assets/AboutUs.webp";
const AboutUs = () => {
    return (
        <div className="py-5 mt-5">
            <Container>
                {/* About Us Section with Image */}
                <Row className="align-items-center mb-5">
                    <Col md={6}>
                        <motion.div
                            initial={{ opacity: 0, x: -50 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.8 }}
                        >
                            <Image src={AboutUsImage} fluid rounded className="shadow-lg" alt="Company" />                        </motion.div>
                    </Col>
                    <Col md={6}>
                        <motion.div
                            initial={{ opacity: 0, x: 50 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.8 }}
                            className="text-center"
                        >
                            <h1 className="display-4 fw-bold text-black">Madhu Sewing Machine Sales & Services</h1>
                            <p className="lead text-black">
                                Your one-stop destination for high-quality sewing machines, expert repairs, and premium spare parts.
                            </p>
                        </motion.div>
                    </Col>
                </Row>

                {/* Services Offered */}
                <Row className="mb-5 text-center">
                    {["Sewing Machines", "Machine Repairs", "Customization", "Spare Parts"]
                        .map((service, index) => (
                            <Col md={3} key={index} className="mb-4">
                                <motion.div
                                    initial={{ opacity: 0, y: 50 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.8, delay: index * 0.2 }}
                                    className="p-4 bg-white shadow rounded"
                                >
                                    <h4 className="fw-bold text-black">{service}</h4>
                                    <p className="text-muted text-black">We offer the best quality in {service.toLowerCase()}.</p>
                                </motion.div>
                            </Col>
                        ))}
                </Row>

                {/* Why Choose Us Section */}
                <motion.div
                    className="text-center mb-5"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.8 }}
                >
                    <Card className="p-4 shadow-lg">
                        <Card.Body>
                            <h2 className="fw-bold text-black mb-4">Why Choose Us?</h2>
                            <Row>
                                <Col md={6}>
                                    <ul className="list-unstyled text-start mx-auto text-black" style={{ maxWidth: "500px" }}>
                                        <li>✅ 10+ Years of Experience</li>
                                        <li>✅ High-Quality Products & Services</li>
                                        <li>✅ Expert Technicians</li>
                                    </ul>
                                </Col>
                                <Col md={6}>
                                    <ul className="list-unstyled text-start mx-auto text-black" style={{ maxWidth: "500px" }}>
                                        <li>✅ Affordable Pricing</li>
                                        <li>✅ Customer Satisfaction Guaranteed</li>
                                        <li>✅ Quick Service Turnaround</li>
                                    </ul>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </motion.div>

                {/* Additional Features */}
                <motion.div className="text-center mb-5" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8 }}>
                    <h2 className="fw-bold text-black mb-4">Our Commitment</h2>
                    <Row>
                        <Col md={4}>
                            <Card className="p-4 shadow-lg text-center">
                                <Card.Body>
                                    <h4 className="fw-bold text-black">🔧 Innovative Solutions</h4>
                                    <p className="text-black">We continuously improve our products and services to meet customer needs.</p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className="p-4 shadow-lg text-center">
                                <Card.Body>
                                    <h4 className="fw-bold text-black">🎯 Customer First</h4>
                                    <p className="text-black">We prioritize customer satisfaction and strive for excellence in service.</p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className="p-4 shadow-lg text-center">
                                <Card.Body>
                                    <h4 className="fw-bold text-black">🌱 Sustainability</h4>
                                    <p className="text-black">We use eco-friendly practices and promote sustainability in our operations.</p>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </motion.div>

                {/* Contact Section (Inquiry removed) */}
                <Row className="mb-5">
                    <Col md={12} className="mb-4">
                        <motion.div initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.8 }}>
                            <Card className="p-4 shadow-lg">
                                <Card.Body>
                                    <h2 className="fw-bold text-black">Contact Us</h2>
                                    <p className="text-black"><strong>📍 Address:</strong> 216, 1st Cross, Magadi Main Rd, near Prasanna Theater, Vidyaranya Nagar, Bengaluru, Karnataka 560023</p>
                                    <p className="text-black"><strong>📞 Phone:</strong> 6366718889</p>
                                    <p className="text-black"><strong>📧 Email:</strong> <a href="mailto:support@madhu-sewing.com" className="text-primary">support@madhu-sewing.com</a></p>
                                    <p className="text-black"><strong>⏰ Working Hours:</strong> Monday - Friday: 9:00 AM - 6:00 PM</p>
                                </Card.Body>
                            </Card>
                        </motion.div>
                    </Col>
                </Row>
                <div className="mb-5">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.976961464575!2d77.54827007367156!3d12.973325314843311!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae3dfb29666fbb%3A0xeebc67c0e2fa35ce!2sMADHU%20SEWING%20MACHINE%20-%20HSW%20Embroidery%20Machine!5e0!3m2!1sen!2sin!4v1762170805164!5m2!1sen!2sin" width="100%" height="400" style={{ border: "0" }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                </div>
            </Container>
        </div>
    );
};

export default AboutUs;
